import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { RootState } from "../index";

export interface LoaderState {
  loading: boolean,
  message: string
  activeCount: number
}

const initialState: LoaderState = {
  loading: false,
  message: 'Loading...',
  activeCount: 0
};

export const loaderSlice = createSlice({
  name: 'loader',
  initialState,
  reducers: {
    showLoader: (state: LoaderState, action: PayloadAction<string>) => {
      if (!!action.payload) state.message = action.payload;
      state.loading = true;
    },
    dismissLoader: (state: LoaderState) => {
      state.loading = false;
      state.message = 'Loading...';
    },
    updateLoaderMessage: (state: LoaderState, action: PayloadAction<string>) => {
      state.message = action.payload;
    }
  }
});

export const {
  showLoader,
  dismissLoader,
  updateLoaderMessage
} = loaderSlice.actions;

export const loaderReducer = (state: RootState) => state.loader;

export default loaderSlice.reducer;
